const SERVICE = "market";

const coupon = async (api, id) =>
  api.setMethod().get().setService(SERVICE).process(`/coupon/${id}`);

const couponByName = async (api, name) =>
  api.setMethod().get().setService(SERVICE).process(`/${name}`);

const couponSuggestion = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/coupon/suggestion");

const applyForCoupon = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/coupon/apply");

module.exports = {
  coupon,
  couponByName,
  couponSuggestion,
  applyForCoupon,
};
